import React from "react";

/**
 * @return {string}
 */
export function CheckEmptyTranslationField(items) {
    for(let i = 0; i < items.length; i ++){
        if(items[i].samoanPhrase === '')
        {
            return ('Samoan Phrase cannot be left empty')
        }
        if(items[i].englishPhrase === '')
        {
            return ('English Phrase cannot be left empty')
        }
        return '';
    }
}
